/**
 * Labstep
 *
 * @module screens/PurchaseOrder/Print
 * @desc Display printable version of an PurchaseOrder
 */

import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import Print from 'labstep-web/core/Print';
import { EntityExport } from 'labstep-web/models/entity-export.model';
import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import type React from 'react';
import type { PurchaseOrderPrintScreenProps } from './types';

export const PurchaseOrderPrintScreen: React.FC<
  PurchaseOrderPrintScreenProps
> = ({ match }) => (
  <EntityCreateContainer entityName={EntityExport.entityName}>
    {({ status, create }) => (
      <Print
        id={match.params.id}
        entityName={PurchaseOrder.entityName}
        status={status}
        create={create}
      />
    )}
  </EntityCreateContainer>
);
